import Freehold from './ownerTypes/freehold';
import Cooperative from './ownerTypes/cooperative';
import Stock from './ownerTypes/stock';

const OWNERTYPES = {
  Freehold,
  Cooperative,
  Stock
};

export default OWNERTYPES;